"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApptFilterContainer = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.ApptFilterContainer = styled_1.default.div `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  #additional-filters-button {
    align-self: start;
    padding: 0 !important;

    &:focus,
    &:hover {
      background-color: transparent;
      border-color: transparent;
    }
  }
`;
//# sourceMappingURL=styles.js.map